import {getAccessToken} from "../helpers/accessTokenManager";

const gotoSignIn = () => {
    if(window.location.pathname.length > 1) {
        let path = window.location.pathname.substring(1) + window.location.search
        console.log("path", path)
        window.location = '/SignIn?redirect=' + encodeURIComponent(path);
    }
    else
        window.location = '/SignIn';
}

const get = async (path) => {
    let response = await fetch(path, {
        "headers": {
            "Authorization": "Bearer " + getAccessToken(),
        },
        "method": "GET"
    });
    if (!response.ok) {
        let error = await response.json();
        if(error.status === 401)
            gotoSignIn();
        throw new Error(error.message);
    }
    return await response.json();
}

const getText = async (path) => {
    let response = await fetch(path, {
        "headers": {
            "Authorization": "Bearer " + getAccessToken(),
        },
        "method": "GET"
    });
    if (!response.ok) {
        let error = await response.json();
        if(error.status === 401)
            gotoSignIn();
        throw new Error(error.message);
    }
    return await response.text();
}

const post = async (path, body) => {
    let response = await fetch(path, {
        "headers": {
            "Authorization": "Bearer " + getAccessToken(),
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        },
        "method": "POST",
        "body": JSON.stringify(body)
    });
    if (!response.ok) {
        let error = await response.json();
        if(error.status === 401) {
            gotoSignIn();
        }
        throw new Error(error.message);
    }
    return await response.json();
}

export const getContentList = async () => await get("/elastic-meetings/v1/contents");
export const getContent = async (contentId) => await get(`/elastic-meetings/v1/contents/${contentId}`);
export const getMeetingList = async () => await get("/elastic-meetings/v1/meetings");
export const getMeeting = async (id) => await get(`/elastic-meetings/v1/meetings/${id}`);
export const getContentVersionList = async (type) => await get(`/page_similarity_${type}/v1/versions`);
export const getSimilarContent = async (type, body) => await post(`/page_similarity_${type}/v1/similar`, body);
export const getSimilarContentToVersion = async (contentVersionId, page) => await post(`/page_similarity_postgres_vector/v1/similar/${contentVersionId}/${page}`);

export const getEngagementCenterData = async(body) => await post(`
https://ses-edge-prod-az-westus-sloth.seismic.com/api/ses/v2/engagements`, body);


export const resolveExternalMeeting = async (externalMeetingId) => await get(`/meeting/v1/meetings/resolve/${encodeURIComponent(externalMeetingId)}`);
export const getUsers = async () => await get("/meeting/v1/meetinghosts");
export const getMeetings = async (userId) => await get(`/meeting/v1/meetings/${userId}`);

export const getAimlMeeting = async (meetingId) => await get(`/meeting/v1/meeting/${meetingId}/aiml`);
export const getParticipants = async (meetingId) => await get(`/meeting/v1/meeting/${meetingId}/participants`);
export const getRecordings = async (meetingId) => await get(`/meeting/v1/meeting/${meetingId}/recordings`);
export const getMeetingRecordingUrl = async (meetingId, recordingId) => await get(`/meeting/v1/meeting/${meetingId}/recordings/${recordingId}/download`);
export const getSentences = async (meetingId) => await get(`/meeting/v1/meeting/${meetingId}/sentences`);
export const getVtt = async (meetingId) => await getText(`/meeting/v1/meeting/${meetingId}/vtt`);
export const getSummary = async (meetingId) => await get(`/meeting/v1/meeting/${meetingId}/summary`);
export const getDocumentRecommendations = async (meetingId) => await get(`/meeting/v1/meeting/${meetingId}/documentRecommendations`);
export const getPresentedContent = async (meetingId) => await get(`/meeting/v1/meeting/${meetingId}/presented_content`);
export const getManifest = async (meetingId) => await get(`/meeting/v1/meeting/${meetingId}/manifest`);

export const getIbmAnalysis = async (meetingId) => await get(`/meeting/v1/meeting/${meetingId}/ibmanalysis`);
export const getGptAnalysis = async (meetingId, model) => await get(`/meeting/v1/meeting/${meetingId}/gptanalysis/${model}`);
export const getMicrosoftAnalysis = async (meetingId) => await get(`/meeting/v1/meeting/${meetingId}/microsoftanalysis`);
export const getTranscriptText = async (meetingId) => await getText(`/meeting/v1/meeting/${meetingId}/transcript/text`);
export const getTranscriptJson = async (meetingId) => await get(`/meeting/v1/meeting/${meetingId}/transcript/json`);

export const search = async (searchText) => await get(`/livesend/v1/search?searchTer/m=${encodeURIComponent(searchText)}`);
export const getRecommendations = async (body) => await post(`/livesend/v1/recommendation`, body);
export const initRecommendationStream = async (body) => await post(`/livesend/v1/recommendation/stream/init`, body);
export const submitFeedback = async (body) => await post(`/livesend/v1/recommendation/feedback`, body);

export const getGptResponse = async (meetingId, body) => await post(`/meeting/v1/meeting/${meetingId}/gpt`, body);
export const getSnowflakeSummaries = async (meetingId) => await get(`/meeting/v1/meeting/${meetingId}/snowflakeSummaries`);
export const getSnowflakeRecommendations = async (meetingId) => await get(`/meeting/v1/meeting/${meetingId}/snowflakeRecommendations`);
export const getEngagement = async (id) => await get(`/engagement/v1/engagements/${id}`);

//Lineage
export const getLineageOriginContents = async () => await get(`/lineage/v1/origin_contents`);
export const getLineageOriginContent = async (originLibraryContentVersionId) => await get(`/lineage/v1/origin_contents/${originLibraryContentVersionId}`);
export const getLineageDebugInfo = async (contentVersionId) => await get(`lineage/v1/debug/${contentVersionId}`);

//Visual Version History
export const getLatestContentVersions = async () => await get("version_history/v1/versions");
export const getContentVersionHistory = async (id) => await get(`version_history/v1/versions/${id}`);

//Clusters
export const getClusters = async () => await get("clusters/v1/clusters");
export const getCluster = async (id) => await get(`clusters/v1/clusters/${id}`);

//Clusters
export const getLivedocCandidates = async () => await get("livedoc/v1/latest_content_versions");
export const getLivedocCandidate = async (id) => await get(`livedoc/v1/latest_content_versions/${id}`);
export const generateLivedoc = async (body) => await post(`livedoc/v1/generate_livedoc`, body);

//Content Usage
export const getContentUsage = async (lookbackDays, old) => await get(`content_usage/v1/content_usage?lookbackDays=${lookbackDays}&old=${old}`);
export const getContentUsageDetail = async (contentVersionId, page, lookbackDays, old) => await get(`content_usage/v1/content_usage/detail?contentVersionId=${contentVersionId}&page=${page}&lookbackDays=${lookbackDays}&old=${old}`);

